import InlineCkEditor from 'Shared/components/CKEditor/InlineCkEditor'
import BlockStyles from "../../BlockStyles"
import LiquidValidator from 'Shared/components/LiquidValidator/LiquidValidator'

const ParagraphV2Block = ({ block, active }) => {
  const act = useAct()
  const { mergeTags } = useSel(s => s.campaignBuilder)
  const setText = (text) => act.email.blocks.updateParameters(block.id, { text })
  const setSourceMode = (sourceMode) => act.email.blocks.updateParameters(block.id, { sourceMode })
  const mergeTagTests = useSel((s) => _.values(s.mergeTagTests.entities))
  const previewHtml = (block.parameters.text && block.parameters.text.length > 0) ? block.parameters.text : '<i>Click to enter text</i>'

  const allMergeTags = () => {
    if (!mergeTagTests || mergeTagTests.length == 0) {
      return mergeTags;
    }
    return { ...mergeTags, "Experiments": mergeTagTests.map(t => ({ label: t.name, slug: 'tests.' + t.slug, featured: false })) };
  }

  return (
    <div id={`block_${block.id}`}>
      {!active && <div dangerouslySetInnerHTML={{ __html: previewHtml }} />}
      {active && <>
        <InlineCkEditor
          value={block.parameters.text}
          sourceMode={block.parameters.sourceMode}
          setSourceMode={setSourceMode}
          onUpdate={setText}
          mergeTags={mergeTags}
          features={['sourceMode', 'tables']}
        />
        <LiquidValidator value={block.parameters.text} lineSplitTags={!block.parameters.sourceMode} availableTags={allMergeTags()} />
      </>}

      <BlockStyles block={block} active={active} />
    </div>
  )
}

export default ParagraphV2Block
